import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { AppConfigService } from '@core/services/app-config.service';

/**
 * Initialize the application with configuration preloading
 */
async function initApp() {
	try {
		// Create the app instance
		const appRef = await bootstrapApplication(AppComponent, {
			...appConfig,
			providers: [provideZoneChangeDetection(), ...appConfig.providers],
		});

		// Get the config service from the injector
		const configService = appRef.injector.get(AppConfigService);

		// Load the configuration
		await configService.loadConfig();

		// Log the environment information
		configService.getConfig();
		// console.log(`Application started in ${config.production ? 'production' : 'development'} mode (v${config.version})`);
	} catch (error) {
		console.error('Application initialization failed:', error);
	}
}

// Start the application initialization
void initApp();
